
export { stringIsValidIsoDate } from "/home/runner/work/apollo/apollo/packages/core/utils/validations/src/string-is-valid-iso-date/string-is-valid-iso-date.ts"